import { render, staticRenderFns } from "./ColposcopyHistoryForm.vue?vue&type=template&id=f6a133b2&"
import script from "./ColposcopyHistoryForm.vue?vue&type=script&lang=js&"
export * from "./ColposcopyHistoryForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports